import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import GameSceneRace from './GameSceneRace';

	type FunctionName = () => any;

class Grass {

	instancedGeometry: any = null!;
	instancedMaterial: any = null!;

	INSTANCED_MESH_ALPHATEST: any = null!;
	
	dummyObj: any = null!;
	
	instanceMatrix: THREE.Matrix4 = null!;

    SETTINGS = {
        transparencyTechnique: 'alphaTest',
        time: 0,
//        terrainSize: 128,
//        hasFog: true,
        hasWind: true,
    };

	grassTechnique: string;

	gameSceneRace: GameSceneRace;
	
//	constructor(grassTechnique: string, loadingCallback: FunctionName) {
	constructor(grassTechnique: string, gameSceneRace: GameSceneRace) {
		// 
		
		this.grassTechnique = grassTechnique; 
		
		///this.grassLoading(loadingCallback);
		this.gameSceneRace = gameSceneRace; 
		
		this.grassLoading();
		
	}
	/////////////////////////////////////////////////////////
	onGrassLoaded(grass: any) {
		//
		
		console.log('onGrassLoaded, grass = ' + grass);

//const instancedCountMax = 100;

		this.instancedGeometry = grass.geometry.clone();
		this.instancedMaterial = grass.material.clone();
		
        // generic stuff
		this.instancedGeometry.translate(0, 0, -1);
		this.instancedMaterial.side = THREE.DoubleSide;
		this.instancedMaterial.blending = THREE.NormalBlending;
		
		//grass.visible = false;

		this.dummyObj = grass;
		
	}
	/////////////////////////////////////////////////////////
	grassLoading() {
		
		const loader = new GLTFLoader();
		loader.load('models/Grass.gltf', (gltf) => {
			
			this.onGrassLoaded(gltf.scene.children[0]);
			
			this.gameSceneRace.grassLoaded = true;
						
		},
		(xhr) => {
			console.log('grass loading: ' + (xhr.loaded / xhr.total) * 100 + '% loaded');
		},
		(error) => {
			console.log('grass loading error! ' + error);
		});
	}
	/////////////////////////////////////////////////////////
	getSettings() {
		return this.SETTINGS;
	}
	/////////////////////////////////////////////////////////
//	createLawn(maxGrassCount: number) {
	createLawn(maxGrassCount: number, settings: any) {
		
        // alphaTest version
        const alphaTestMaterial = this.instancedMaterial.clone();
		alphaTestMaterial.alphaTest = 0.5;
		alphaTestMaterial.transparent = false;
		alphaTestMaterial.depthWrite = true;
		
        const instancedMesh = new THREE.InstancedMesh(this.instancedGeometry, alphaTestMaterial, maxGrassCount);
        
//        instancedMesh.onBeforeRender = function(deltaTime: number, elapsedTime : number) {
        instancedMesh.onBeforeRender = function() {
			//
			
			
		};
        
        
        

		/*
        // depthWrite version
        const depthWriteMaterial = instancedMaterial.clone();
        depthWriteMaterial.alphaTest = 0;
        depthWriteMaterial.transparent = true;
        depthWriteMaterial.depthWrite = false;
        INSTANCED_MESH_DEPTHWRITE = new THREE.InstancedMesh(instancedGeometry, depthWriteMaterial, instancedCount);
        INSTANCED_MESH_DEPTHWRITE.instanceMatrix.setUsage( THREE.DynamicDrawUsage );
		*/

		this.instanceMatrix = new THREE.Matrix4();

 //         instancedMesh.visible = false;

		
          instancedMesh.castShadow = true;
          instancedMesh.receiveShadow = true;

          // for shadows
          instancedMesh.customDepthMaterial = new THREE.MeshDepthMaterial( {
            depthPacking: THREE.RGBADepthPacking,
            map: instancedMesh.material.map,
            alphaTest: 0.25,
          });




//работает криво (вместо красивой анимации получилось дрожание с раздвоением), нужно переделать отправку времени в шейдер

          // add some movement to the shader (completely optional)
          instancedMesh.material.onBeforeCompile = function(shader: any, renderer: any) {
			
            const editVertexShader = function(searchFor: any, prepend = '', append = '') {
              shader.vertexShader = shader.vertexShader.replace(searchFor, [prepend, searchFor, append].join('\n'));
            };

            shader.uniforms.time = {
              get value() {
//                return this.SETTINGS.hasWind ? this.SETTINGS.time : 0;
                return settings.hasWind ? settings.time : 0;
              },
            };
            editVertexShader('#include <common>', `
              uniform float time;
            `);
            editVertexShader('#include <project_vertex>', `
              vec4 worldGrassPos = vec4( position, 1.0 ) * instanceMatrix;
              vec2 oscillation = sin(time * 5.0 * worldGrassPos.xy) + cos(time * 2.0 * worldGrassPos.xy);
              transformed.xy += oscillation.xy * min(1.0, position.z) * 0.0075;
            `);
          };
		
		
		
		return instancedMesh;
	}
	/////////////////////////////////////////////////////////
	addGrassInstance(lawn: THREE.InstancedMesh, index: number, x: number, y: number, z: number, rotation: number, scale: number) {
		
		this.dummyObj.position.x = x;
		this.dummyObj.position.y = y;
		this.dummyObj.position.z = z;

		this.dummyObj.rotation.z = rotation;  // точно вокруг z, не y?
		this.dummyObj.scale.x = this.dummyObj.scale.y = this.dummyObj.scale.z = scale;

		this.instanceMatrix.compose(this.dummyObj.position, this.dummyObj.quaternion, this.dummyObj.scale);

		lawn.setMatrixAt(index, this.instanceMatrix);  // index придётся хранить в графическом квадрате, т.к. в THREE.InstancedMesh есть только счётчик-ограничитель, а нормальный не сделали 
		
	}
	/////////////////////////////////////////////////////////
	
}
export default Grass;